"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgBatteryCharging = function SvgBatteryCharging(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M18.19 17a1 1 0 010 2H15a1 1 0 00-1 1v8a1 1 0 001 1h2a1 1 0 010 2h-2a3 3 0 01-3-3v-8a3 3 0 013-3h3.19zM29 17a3 3 0 013 3v8a3 3 0 01-3 3h-3.19a1 1 0 010-2H29a1 1 0 001-1v-8a1 1 0 00-1-1h-2a1 1 0 010-2h2zm-5.444.168a1 1 0 01.278 1.387L20.87 23h4.132a1 1 0 01.832 1.555l-4 6a1 1 0 01-1.664-1.11L23.133 25h-4.131a1 1 0 01-.832-1.555l4-6a1 1 0 011.386-.277zM35 22a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1z",
    id: "battery-charging_svg__a"
  }));
};

var _default = SvgBatteryCharging;
exports["default"] = _default;